import { Seo } from "@/components/Seo";
import { breadcrumbJsonLd } from "@/components/Breadcrumb";
import { ServiceHero } from "@/components/service/ServiceHero";
import { IncludedList } from "@/components/service/IncludedList";
import { BodySections } from "@/components/service/BodySections";
import { Faq, faqJsonLd } from "@/components/service/Faq";
import { RelatedServices } from "@/components/service/RelatedServices";
import { AreasStrip } from "@/components/service/AreasStrip";
import { Process } from "@/components/home/Process";
import { CtaBand } from "@/components/home/CtaBand";

export default function ServicePage({ service }) {
  const breadcrumb = [
    { label: "Home", to: "/" },
    { label: "Services", to: "/services" },
    { label: service.name, to: service.path },
  ];
  const jsonLd = [breadcrumbJsonLd(breadcrumb), faqJsonLd(service.faqs)];

  return (
    <div data-testid={`service-page-${service.id}`}>
      <Seo title={service.title} description={service.metaDescription} jsonLd={jsonLd} />
      <ServiceHero h1={service.h1} intro={service.intro} image={service.image} breadcrumb={breadcrumb} />
      <IncludedList items={service.included} serviceName={service.name} />
      <BodySections sections={service.sections} />
      <Process />
      <Faq faqs={service.faqs} serviceName={service.name} />
      <RelatedServices related={service.related} />
      <AreasStrip serviceName={service.name} />
      <CtaBand />
    </div>
  );
}
